import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from 'src/redux/store';
// components
import LoadingScreen from '../components/loading-screen';
//

// ----------------------------------------------------------------------

type GuestGuardProps = {
  children: ReactNode;
};

export default function GuestGuard({ children }: GuestGuardProps) {
  const { isAuthenticatedWeb2, isInitialized } = useAppSelector(store => store.auth);

  if (isAuthenticatedWeb2) {
    return <Navigate to="/dashboard" />;
  }

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  return <> {children} </>;
}
